import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'

const BANNER_BACKGROUND =
  '4df0ba1b5dfa1e6fa897581cfee49797.png'

const BottomBanner = () => (
  <section className="overflow-hidden relative w-full group" style={{ height: 480 }}>
    <div
      className="absolute inset-0 bg-center bg-no-repeat bg-cover transition-transform duration-700 ease-out group-hover:scale-105"
      style={{ backgroundImage: `url(${preFixImgUrl(BANNER_BACKGROUND)})` }}
      aria-hidden
    />

    <div className="relative z-[1] mx-auto flex h-full w-[1200px] flex-col items-center justify-center pb-[28px] text-center text-white">
      <LangText
        lngKey="coupon.bottomBanner.title"
        className="text-[36px] font-bold leading-[50px]"
      />
      <LangText
        lngKey="coupon.bottomBanner.description"
        className="mt-[16px] text-[28px] leading-[40px]"
      />
    </div>
  </section>
)

export default BottomBanner
